import React from "react";
import { Sample, Strip } from "./ColorStrip.styles";
import type { ColorStripProps } from "./ColorStrip.types";

/** A palette at a glance: thin bars or square swatches in order. */
export const ColorStrip: React.FC<ColorStripProps> = ({ colors, variant = "bars", leadWide = false, label, className }) => (
  <Strip
    className={className}
    $variant={variant}
    role={label ? "img" : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
    data-testid="color-strip"
  >
    {colors.map((color, index) => (
      <Sample key={`${index}-${color}`} $color={color} $variant={variant} $wide={leadWide && index === 0} data-color={color} />
    ))}
  </Strip>
);

export default ColorStrip;
